export default __webpack_public_path__ + "static/media/stop_auto_overlay.ef4aaf5b.svg";